import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { type Observable } from "rxjs";
import {
	type CreateFloorplanInput,
	type Floorplan,
	type UpdateFloorplanInput,
} from "src/app/schema";
import { ApiService } from "src/app/services";

@Injectable({
	providedIn: "root",
})
export class FloorplanService {
	private readonly _api = inject(ApiService);
	private readonly _httpClient = inject(HttpClient);

	public createFloorplan(
		floorplan: CreateFloorplanInput,
	): Observable<Floorplan> {
		return this._httpClient.post<Floorplan>(
			`${this._api.inventoryApiEndpoint}/floorplan`,
			floorplan,
		);
	}

	public updateFloorplan(
		floorplan: UpdateFloorplanInput,
	): Observable<Floorplan> {
		return this._httpClient.put<Floorplan>(
			`${this._api.inventoryApiEndpoint}/floorplan`,
			floorplan,
		);
	}

	public deleteFloorplan(floorplan: Floorplan): Observable<{ id: string }> {
		return this._httpClient.delete<{ id: string }>(
			`${this._api.inventoryApiEndpoint}/floorplan/${floorplan.id}`,
		);
	}
}
